(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("license-plate", [], factory);
	else if(typeof exports === 'object')
		exports["license-plate"] = factory();
	else
		root["license-plate"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 